import styled from '@emotion/styled';

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const UsersAccessDetailsHeaderButtons = styled.section`
  display: flex;
  button {
    width: auto;
    margin-right: 16px;
  }
`;

export const StyledTitle = styled.div`
  display: flex;
  flex-direction: column;

  span {
    margin-top: -2rem;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.palette?.text?.secondary};
  }
`;
